<template>
  <div class="bg-brand fixed-top">
    <b-navbar toggleable="lg" type="dark" class="shadow">
      <b-navbar-brand href="#"><img :src="logo" alt="" id="logo"/></b-navbar-brand>
      <b-nav-item class="ml-5"><router-link to="/Home">HOME</router-link></b-nav-item>
      <b-nav-item><router-link to="/Pedidos" href="#filtroPedido">PEDIDOS</router-link></b-nav-item>
      <b-nav-item><router-link to="/Clientes">CLIENTES</router-link></b-nav-item>
      <b-nav-item><router-link to="/Relatorios">RELATÓRIOS</router-link></b-nav-item>
      <b-nav-item><router-link to="/Catalogo">CATÁLOGO</router-link></b-nav-item>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-form class="mr-4" v-show="viewListaRepresentantes && this.listaRepresentantes.length > 1"> -->
        <b-nav-form class="mr-4" id="selecRepDesk">
          <div v-if="this.listaRepresentantes.length > 1 && viewListaRepresentantes === false" class="contentRepSelecao">
            <div v-if="this.representanteSelecionado">
              <img v-if="this.representanteSelecionado.urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="ml-1 mr-1 fotoRepBtn" />
              <img v-else :src="this.representanteSelecionado.urlFoto" class="ml-1 mr-1 fotoRepBtn" />
              <span>{{toCapitalize(this.representanteSelecionado.apelido)}}</span>
            </div>
          </div>
          <div v-else-if="this.listaRepresentantes.length > 1" class="btnRepSelec contentRepSelecao" @click="abreModalSelecRep()">
            <div v-if="this.representanteSelecionado" class="btn btn-secondary">
              <img v-if="this.representanteSelecionado.urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="ml-1 mr-1 fotoRepBtn" />
              <img v-else :src="this.representanteSelecionado.urlFoto" class="ml-1 mr-1 fotoRepBtn" />
              <span>{{toCapitalize(this.representanteSelecionado.apelido)}}</span>
            </div>
            <button v-else class="btn btn-secondary btnSelecionar" @click="abreModalSelecRep()" :style="cor2" style="border: none">Selecionar Representante</button>
          </div>
          <div v-else-if="this.listaRepresentantes.length === 1" class="contentRepSelecao">
            <div>
              <img v-if="this.listaRepresentantes[0].urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="ml-1 mr-1 fotoRepBtn" />
              <img v-else :src="this.listaRepresentantes[0].urlFoto" class="ml-1 mr-1 fotoRepBtn" />
              <span><b>{{toCapitalize(this.listaRepresentantes[0].apelido)}}</b></span>
            </div>
          </div>
        </b-nav-form><!-- {{this.representanteSelecionado}} -->
        <b-nav-item-dropdown text="User" right id="menuUsuario">
          <template slot="button-content"><i class="fas fa-user-circle"></i></template>
          <div id="selecRepMob">
            <b-dropdown-item v-if="this.listaRepresentantes.length > 1 && viewListaRepresentantes === false" class="contentRepSelecao">
              <div v-if="this.representanteSelecionado">
                <img v-if="this.representanteSelecionado.urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="ml-1 mr-1 fotoRepBtn" />
                <img v-else :src="this.representanteSelecionado.urlFoto" class="ml-1 mr-1 fotoRepBtn" />
                <span>{{toCapitalize(this.representanteSelecionado.apelido)}}</span>
              </div>
            </b-dropdown-item>
            <b-dropdown-item v-else-if="this.listaRepresentantes.length > 1" class="btnRepSelec contentRepSelecao" @click="abreModalSelecRep()">
              <div v-if="this.representanteSelecionado" class="btn btn-secondary">
                <img v-if="this.representanteSelecionado.urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="ml-1 mr-1 fotoRepBtn" />
                <img v-else :src="this.representanteSelecionado.urlFoto" class="ml-1 mr-1 fotoRepBtn" />
                <span>{{toCapitalize(this.representanteSelecionado.apelido)}}</span>
              </div>
              <button v-else class="btn btn-secondary btnSelecionar" @click="abreModalSelecRep()" :style="cor2" style="border: none">Selecionar Representante</button>
            </b-dropdown-item>
            <b-dropdown-item v-else-if="this.listaRepresentantes.length === 1" class="contentRepSelecao">
              <img v-if="this.listaRepresentantes[0].urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="ml-1 mr-1 fotoRepBtn" />
              <img v-else :src="this.listaRepresentantes[0].urlFoto" class="ml-1 mr-1 fotoRepBtn" />
              <span><b>{{toCapitalize(this.listaRepresentantes[0].apelido)}}</b></span>
            </b-dropdown-item>
          </div>
          <!-- <b-dropdown-item href="#">Editar Perfil</b-dropdown-item>
          <b-dropdown-item href="#">Configurações</b-dropdown-item>
          <b-dropdown-item href="#">Ajuda</b-dropdown-item> -->
          <b-dropdown-item v-on:click="sair">Sair</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <b-modal
      title="Selecione um Representante"
      v-model="modalSelecRepresentante"
      ok-title="Salvar"
      ok-variant="primary"
      cancel-title="Fechar"
      cancel-variant="secondary"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      hide-footer>
      <b-row class="p-0 mb-1" id="filtroRepresentante">
        <b-form-input type="text" size="sm" v-model="codigoRep" placeholder="Código" class="col-md-3" />
        <b-form-input type="text" size="sm" v-model="apelidoRep" placeholder="Representante" class="col-md-8" />
        <b-button class="btnLimpaFiltroRep col-md-1" size="sm" v-on:click="limparFiltro()"><i class="fas fa-eraser mr-2"></i></b-button>
      </b-row>
      <b-row class="table tab-rep p-0">
        <b-table bordered striped :items="filteredList" :fields="fieldsRepresentantes" class="m-0" v-if="filteredList.length > 0">
          <template slot="urlFoto" slot-scope="row">
            <img v-if="row.item.urlFoto === ''" src="@/assets/sem-imagem.png" alt="" class="fotoRepModal" />
            <img v-else :src="row.item.urlFoto" class="m-1 fotoRepModal" />
          </template>
          <template slot="acao" slot-scope="row">
            <b-button size="sm" @click="admSelecRep(row.item, row.index)" class="mr-1">
              Selecionar
              <!-- {{row.item.isEditavel ? 'Editar' : 'Visualizar'}} -->
            </b-button>
          </template>
        </b-table>
        <span v-else>
          Não foram encontrados representantes com o termo pesquisado, tente novamente
        </span>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import { broadcastServer } from '@/main'
  import { ModelListSelect } from 'vue-search-select'
  export default {
    name: 'HeaderVue',
    components: {
      ModelListSelect
    },
    computed: {
      logo () {
        return this.$store.state.isLog.empresa
      },
      filteredList () {
        return this.listaRepresentantes.filter(post => {
          return post.codigo.includes(this.codigoRep) && post.apelido.toLowerCase().includes(this.apelidoRep.toLowerCase())
        })
      }
    },
    data () {
      return {
        codigoRep: '',
        apelidoRep: '',
        headerTextVariant: 'light',
        headerBgVariant: 'dark',
        modalSelecRepresentante: false,
        representanteSelecionado: null,
        viewListaRepresentantes: false,
        listaRepresentantes: [],
        fieldsRepresentantes: [
          {
            key: 'urlFoto',
            label: 'Foto'
          },
          {
            key: 'codigo',
            label: 'Código'
          },
          {
            key: 'apelido',
            label: 'Representante',
            formatter: this.toCapitalize,
            class: 'txtLeft'
          },
          {
            label: 'Selecionar',
            key: 'acao'
          }

        ]
      }
    },
    created () {
      this.cor2 = {'background-color': `#${localStorage.getItem('corSelecionado')}`}
    },
    watch: {
      $route (to, from) {
        if (to.name === 'home') {
          this.viewListaRepresentantes = true
        } else {
          this.viewListaRepresentantes = false
        }
      }
    },
    mounted () {
      this.$route.name === 'home' ? this.viewListaRepresentantes = true : this.viewListaRepresentantes = false
      let representantesLogin = JSON.parse(localStorage.getItem('representantesLogin'))
      this.listaRepresentantes = representantesLogin.sort(function (a, b) {
        return a.codigo - b.codigo
      })
      // console.log(this.listaRepresentantes)
    },
    methods: {
      sair: function () {
        localStorage.clear()
        this.$router.push('/')
      },
      admSelecRep: function (item, index) {
        this.representanteSelecionado = item
        localStorage.setItem('representanteSelecionado', JSON.stringify(this.representanteSelecionado))
        broadcastServer.$emit('emitBuscaDadosDashboard', this.representanteSelecionado)
        this.modalSelecRepresentante = false
      },
      abreModalSelecRep: function () {
        event.preventDefault()
        this.modalSelecRepresentante = true
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      limparFiltro: function () {
        this.codigoRep = ''
        this.apelidoRep = ''
      }
    }
  }

</script>
<style scoped>
  i {
    font-size: 20px;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .btnRepSelec {
    cursor: pointer;
  }
  .table {
    overflow-y: scroll;
    position: relative;
    min-height: 60px;
    max-height: 450px;
    font-size: 14px;
    margin-top: 10px;
  }
  .table td {
    vertical-align: middle;
  }
  .fotoRepModal {
    max-width: 100px;
    max-height: 80px;
  }
  .fotoRepBtn {
    max-width: 50px;
    max-height: 30px;
  }
  b-footer {
    font-size: 13px;
  }
  b-footer .nav-link {
    padding: 0;
  }
  .row {
    padding: .5rem 1rem;
  }
  i {
    font-size: 18px;
  }
  a {
    color: #cbcbcb
  }
  .btnLimpaFiltroRep  {
    line-height: 1;
    right: 1px;
  }
  .contentRepSelecao > div {
    line-height: 1.5;
    padding: .375rem .75rem;
  }
  .contentRepSelecao div > span,
  #menuUsuario {
    position: relative;
    top: 2px;
  }
  /*a:hover {*/
    /*color: #ffffff;*/
    /*!* text-decoration: underline; *!*/
    /*font-weight: 900;*/
    /*cursor: pointer;*/
  /*}*/
  li {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/components/layouts/HeaderVue.vue